import { render, staticRenderFns } from "./LevelSettings.vue?vue&type=template&id=65e6cf35"
import script from "./LevelSettings.vue?vue&type=script&lang=ts"
export * from "./LevelSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports